export default [
  ...new Set([
    "Áfri­ca",
    "Á­gua",
    "Á­guia",
    "Índia",
    "Óleo",
    "Ópera",
    "Órgão",
    "Abó­bora",
    "abe­lha",
    "acor­do",
    "acre",
    "adul­to",
    "advo­gado",
    "agente",
    "agulha",
    "ale­manha",
    "alfa­beto",
    "al­go­dão",
    "ali­ení­gena",
    "alma",
    "alpes",
    "alvo",
    "amé­rica",
    "ama­zonas",
    "am­bulân­cia",
    "brasí­lia",
    "anão",
    "anel",
    "anjo",
    "antár­tida",
    "apren­diz",
    "ar",
    "aranha",
    "arco",
    "arquivo",
    "assi­natura",
    "astro",
    "atlân­tida",
    "aus­trá­lia",
    "avião",
    "bíblia",
    "búfalo",
    "baú",
    "bacia",
    "balão",
    "bala",
    "ba­lanço",
    "baleia",
    "banana",
    "banco",
    "banda",
    "ban­heiro",
    "bar",
    "barco",
    "barra",
    "ba­teria",
    "batida",
    "beijing",
    "berlim",
    "ber­muda",
    "bloco",
    "boca",
    "bola",
    "bolo",
    "bolsa",
    "bomba",
    "bordão",
    "botão",
    "bota",
    "braço",
    "bril­han­te",
    "brinco",
    "broto",
    "bruxa",
    "buraco",
    "cír­culo",
    "código",
    "cólera",
    "cabeça",
    "cabo",
    "cacho",
    "cac­hor­ro",
    "ca­deira",
    "café",
    "caixa",
    "calça",
    "calha",
    "cama",
    "camin­hão",
    "ca­min­ho",
    "campo",
    "canadá",
    "can­guru",
    "cano",
    "canto",
    "capa",
    "capital",
    "capuz",
    "cara",
    "carga",
    "caro",
    "carro",
    "cartão",
    "casca",
    "casco",
    "cas­sino",
    "calda",
    "cava­leiro",
    "cavalo",
    "cedo",
    "cela",
    "ce­nou­ra",
    "cen­tauro",
    "centro",
    "cerca",
    "chave",
    "chi­clete",
    "chifre",
    "china",
    "cho­co­late",
    "chur­rasco",
    "chu­veiro",
    "ci­en­tis­ta",
    "cinto",
    "clube",
    "co­ber­tura",
    "cobre",
    "coelho",
    "cola",
    "colher",
    "coluna",
    "com­pos­to",
    "com­pri­mido",
    "con­cer­to",
    "co­ne­xão",
    "conta",
    "conto",
    "con­trato",
    "co­ra­ção",
    "coral",
    "coroa",
    "corpo",
    "cor­reio",
    "cor­ren­te",
    "corte",
    "costa",
    "cré­dito",
    "cravo",
    "cruz",
    "cupim",
    "cura",
    "dado",
    "dente",
    "ar­ran­ha-céu",
    "dia",
    "dia­frag­ma",
    "dia­man­te",
    "di­nos­sau­ro",
    "direi­ta",
    "direi­to",
    "divi­são",
    "doce",
    "doutor",
    "dragão",
    "edi­fício",
    "egito",
    "em­bai­xada",
    "en­contro",
    "en­fer­meira",
    "escala",
    "escola",
    "es­cor­pião",
    "espaço",
    "espião",
    "es­pin­ha",
    "es­quer­da",
    "es­tá­dio",
    "estado",
    "es­tre­la",
    "europa",
    "fé",
    "fós­foro",
    "faca",
    "falcão",
    "fan­tas­ma",
    "fec­ha­dura",
    "fer­ra­dura",
    "ferro",
    "ficha",
    "figura",
    "fila",
    "filme",
    "fita",
    "flauta",
    "flo­res­ta",
    "fluxo",
    "fogo",
    "folha",
    "fonte",
    "força",
    "frança",
    "frio",
    "furo",
    "gás",
    "gêmeos",
    "gênio",
    "galo",
    "gancho",
    "garfo",
    "garoto",
    "gar­rafa",
    "gato",
    "gelo",
    "germe",
    "gi­gan­te",
    "ele­fante",
    "gota",
    "grécia",
    "cigano",
    "grade",
    "grama",
    "grau",
    "gra­vata",
    "guerra",
    "guia",
    "heli­cóp­tero",
    "herói",
    "hima­laia",
    "hor­telã",
    "hos­pital",
    "hotel",
    "igreja",
    "ilha",
    "ingla­terra",
    "ins­cri­ção",
    "júpiter",
    "jogo",
    "justa",
    "língua",
    "laço",
    "la­bora­tório",
    "ladrão",
    "lama",
    "lance",
    "laranja",
    "lava",
    "lava­dora",
    "leão",
    "leito",
    "lesma",
    "leste",
    "libra",
    "liga",
    "limão",
    "limão",
    "limu­sine",
    "linha",
    "lixa",
    "loja",
    "londres",
    "lua",
    "luta­dor",
    "luva",
    "luz",
    "máquina",
    "már­more",
    "mão",
    "mês",
    "mídia",
    "missão",
    "maçã",
    "macaco",
    "magia",
    "mau",
    "mamute",
    "manga",
    "janei­ro",
    "marca",
    "marcha",
    "marfim",
    "massa",
    "mastro",
    "mato",
    "medida",
    "meia",
    "meio",
    "mel",
    "mer­cúrio",
    "mili­oná­rio",
    "carta",
    "méxico",
    "mi­cros­cópio",
    "mina",
    "mo­chila",
    "modelo",
    "mole",
    "morcego",
    "morro",
    "morte",
    "moscou",
    "muda",
    "mudança",
    "mula",
    "nega­tivo",
    "neve",
    "ninja",
    "noite",
    "nota",
    "recife",
    "novela",
    "olho",
    "olimpo",
    "onda",
    "ordem",
    "ouro",
    "pára-que­das",
    "pás­saro",
    "pátio",
    "pé",
    "pó",
    "polo",
    "pací­fico",
    "palha",
    "panela",
    "papel",
    "parada",
    "parede",
    "parque",
    "rádio",
    "par­tida",
    "passado",
    "passo",
    "pata",
    "porca",
    "pauta",
    "pião",
    "peça",
    "pedra",
    "peixe",
    "pen­has­co",
    "peru",
    "piano",
    "piloto",
    "pincel",
    "pinguim",
    "pino",
    "pirâ­mide",
    "pirata",
    "piso",
    "pistola",
    "plás­tico",
    "plano",
    "planta",
    "poder",
    "polícia",
    "polí­tica",
    "pole­gar",
    "polvo",
    "ponte",
    "ponto",
    "pinta",
    "porto",
    "posto",
    "praia",
    "prato",
    "pre­sen­te",
    "pre­sun­to",
    "prima­vera",
    "prin­cesa",
    "pro­fes­sor",
    "pro­grama",
    "prova",
    "quadra",
    "qua­dra­do",
    "quadro",
    "quarto",
    "feira",
    "rainha",
    "raio",
    "raiz",
    "ramo",
    "ras­cun­ho",
    "rato",
    "real",
    "re­creio",
    "rede",
    "rei",
    "reló­gio",
    "revo­lução",
    "rio",
    "robô",
    "roda",
    "rodada",
    "roleta",
    "rolo",
    "roma",
    "rosa",
    "rosca",
    "russo",
    "sapato",
    "saté­lite",
    "satur­no",
    "sede",
    "sela",
    "selo",
    "sen­tença",
    "ser­vidor",
    "sexta",
    "sino",
    "sola",
    "sol­dado",
    "som",
    "sombra",
    "sonho",
    "sorte",
    "sorvete",
    "tênis",
    "tóquio",
    "tanque",
    "teatro",
    "teia",
    "tela",
    "te­les­cópio",
    "templo",
    "tempo",
    "terno",
    "terra",
    "tiro",
    "tocha",
    "toco",
    "tomada",
    "torre",
    "torta",
    "trama",
    "trave",
    "trem",
    "tri­ân­gulo",
    "trilha",
    "tronco",
    "tu­barão",
    "tubo",
    "unha",
    "uni­cór­nio",
    "urso",
    "vácuo",
    "vara",
    "vaso",
    "vela",
    "veneno",
    "vento",
    "verão",
    "verde",
    "verme",
    "ves­tido",
    "viagem",
    "vida",
    "vidro",
    "vo­lan­te",
    "volta",
    "dedo",
    "sal",
    "sol",
    "violão",
    "canela",
    "troco",
    "bri­ga­dei­ro",
    "re­gis­tro",
    "corda",
    "mancha",
    "pelo",
    "fio",
    "cir­cuito",
    "ele­mento",
    "ceda",
    "cera",
    "chuva",
    "ci­ca­triz",
    "bode",
    "man­guei­ra",
    "pipoca"
  ])
];
